module.exports = __webpack_public_path__ + "img/3.2a9eb789.jpg";